import * as React from 'react'
import { StyledFooter } from './style'

const Footer: React.SFC = ({ children }) => <StyledFooter />

export default Footer
